import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from 'ag-grid-community';
import { CustomFilterProps, useGridFilter } from 'ag-grid-react';
import React, { useCallback, useRef } from 'react';
import { filterStyles } from './styles';
import { Button } from 'components/ui';

export default ({ model, onModelChange, colDef }: CustomFilterProps) => {
  const refInput = useRef<HTMLInputElement>(null);

  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const filterText: string = model;
      const rowValue = params.data[colDef.field as string];
      if (rowValue) {
        const filterDate = new Date(filterText);
        const rowDate = new Date(rowValue);
        return (
          rowDate.getDate() === filterDate.getDate() &&
          rowDate.getMonth() === filterDate.getMonth() &&
          rowDate.getFullYear() === filterDate.getFullYear()
        );
      } else {
        return false;
      }
    },
    [model]
  );

  const afterGuiAttached = useCallback((params?: IAfterGuiAttachedParams) => {
    if (!params || !params.suppressFocus) {
      refInput.current?.focus();
    }
  }, []);

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });

  return (
    <div style={filterStyles.container}>
      <div style={filterStyles.container}>
        <input
          ref={refInput}
          type='date'
          style={filterStyles.input}
          value={model || ''}
          onChange={({ target: { value } }) =>
            onModelChange(value === '' ? null : value)
          }
        />
        {model !== null && (
          <Button size='xSmall' onClick={() => onModelChange(null)}>
            Clear
          </Button>
        )}
      </div>
    </div>
  );
};
